// extracted by mini-css-extract-plugin
export var article = "style-module--article--5cbf7";
export var background = "style-module--background--c5bdf";
export var image = "style-module--image--a76a2";
export var logoContainer = "style-module--logoContainer--e016a";
export var opacity = "style-module--opacity--644bb";
export var text = "style-module--text--495de";